// extracted by mini-css-extract-plugin
module.exports =  {"ProposalConsent":"ProposalConsent__XMZt2","consentInfo":"consentInfo__KJpzT","shopInfoConsent":"shopInfoConsent__Zhltu"};